import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import { FONT_SCALE } from "./fontScale";

// The app's font sizes (`text-13`, tailwind.config.js) and the footer watermark's
// `text-mark-*` are sizes, not text colours.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: [...FONT_SCALE.map(String), "mark-sm", "mark-md", "mark-lg"] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
